var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubBid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.69995 9C2.69995 8.7613 2.79477 8.53239 2.96356 8.3636C3.13234 8.19482 3.36126 8.1 3.59995 8.1H14.4C14.6386 8.1 14.8676 8.19482 15.0363 8.3636C15.2051 8.53239 15.3 8.7613 15.3 9C15.3 9.23869 15.2051 9.46761 15.0363 9.63639C14.8676 9.80518 14.6386 9.9 14.4 9.9H3.59995C3.36126 9.9 3.13234 9.80518 2.96356 9.63639C2.79477 9.46761 2.69995 9.23869 2.69995 9Z",
    fill: "#68769F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubBid);
export default __webpack_public_path__ + "static/media/sub-bid.7a20d20d1d3c3a2d236e78ba00a208be.svg";
export { ForwardRef as ReactComponent };